<template>
  <div>
    <static-custom-page :pageSlug="this.$route.params.page_slug" />
    <static-footer :pageObj="CustomPage"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StaticFooter from '@/components/Footer/StaticFooter'
import StaticCustomPage from '@/components/StaticPages/StaticCustomPage'

export default {
  name: 'CustomPage',
  components: {
    StaticCustomPage,
    StaticFooter,
  },
  computed: {
    ...mapGetters(['_T_DB', 'all_static_pages']),
    CustomPage() {
      if (this.all_static_pages) {
        let pSlug = this.$route.params.page_slug
        return this.all_static_pages.find(
          page => page.slug === pSlug
        )
      }
      return {}
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
